module.exports = __webpack_public_path__ + "f1f12143bf469385255f3dbe9115ff41.pdf";